import type { Realisation } from "@/lib/types";

export default function RealisationCard({ item }: { item: Realisation }) {
  return (
    <article className="group bg-background-50 rounded-lg border border-background-200 overflow-hidden transition-transform duration-300 hover:-translate-y-1">
      <div className="relative w-full aspect-[16/10] overflow-hidden">
        <img
          src={item.image}
          alt={item.title}
          title={`${item.title} — Humanity59`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute top-3 left-3 rounded-full bg-primary-500 text-background-50 px-3 py-1 text-xs font-semibold whitespace-nowrap">
          {item.category}
        </span>
      </div>
      <div className="p-5 md:p-6">
        <p className="text-xs font-medium text-accent-600 flex items-center gap-1.5">
          <i className="ri-calendar-line"></i>
          {item.date}
        </p>
        <h3 className="mt-2 font-heading text-lg font-semibold text-foreground-950">
          {item.title}
        </h3>
        <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
          {item.description}
        </p>
      </div>
    </article>
  );
}